export default {
  textCardLogged: (
    <>
      Utilisez cette illustration scientifique <br /> avec plus de 75 000 autres options. <br />{' '}
      Créez de magnifiques designs scientifiques <br /> en quelques minutes.
    </>
  ),
  startCreatingNow: 'Commencer à créer',
  loginForm: {
    login: 'Connectez-vous à votre compte',
    joinUs: 'Rejoignez-nous gratuitement',
  },
  registerFooter: {
    member: 'Déjà membre ?',
    login: 'Connectez-vous plutôt',
  },
  initDescription: 'les',
  description:
    "est la meilleure option pour votre brillant modèle d'infographie. Créez de magnifiques infographies et présentations scientifiques, académiques et éducatives avec cette illustration.",
  customizeInit: 'Personnaliser le',
  customizeDescription:
    "illustration, si nécessaire, et téléchargez, présentez ou partagez votre travail immédiatement. Il s'agit d'un modèle d'infographie réalisé par des scientifiques.",
};
